import React from 'react'
import moment from "moment";
import SvgIcon from "../../../components/svg-icon";

const TicketItem = props => {

    const {ticket} = props

    return (
        <li className="col-12 col-sm-6 col-xxl-3">
            {/*<div className="ticket-item">*/}
            {/*    <div className="up">*/}
            {/*        <span>{title}</span>*/}
            {/*    </div>*/}
            {/*    <div className="down">*/}
            {/*        <span className="ticket-no">#{ticket?.secret}</span>*/}
            {/*        <span className="date">{moment.unix(ticket?.timestamp).format('MMM Do YY')}</span>*/}
            {/*    </div>*/}
            {/*</div>*/}

            <div className="ticket ticket--grid ticket--blue">
                {/*<h3 className="ticket__title">title</h3>*/}
                <span className="ticket__icon">
                    <SvgIcon id={'ticket'}/>
                </span>

                <div>
                    <p className="ticket__text">#{ticket?.id}</p>
                    <span className="ticket__date">{moment.unix(ticket?.timestamp).format('MMM Do YY')}</span>
                </div>

            </div>

        </li>


    )

}


export default React.memo(TicketItem)
